import React from 'react';
import { buildWhatsAppLink } from '../constants';

import suvinilFosco from '../assets/images/products/suvinil-toque-fosco.png';
import mestreBellacor from '../assets/images/products/mestre-bellacor-fosco.png';
import tecplusTop from '../assets/images/products/quartzolit-tecplus-top.png';
import espumaExpansiva from '../assets/images/products/quartzolit-espuma-expansiva.png';
import suvinilSeda from '../assets/images/products/suvinil-toque-seda.png';
import coralRenova from '../assets/images/products/coral-renova.png';

const products = [
  {
    name: 'Suvinil Toque Fosco Completo',
    category: 'Interior/Exterior',
    description: 'Acabamento fosco impecável, super liso e uniforme, com alta resistência à limpeza e ótimo disfarce de imperfeições. Lata de 20L.',
    price: 'a partir de R$ 95,00',
    accent: 'Acrílico Premium',
    image: suvinilFosco,
  },
  {
    name: 'Mestre Acrílico Fosco Bellacor',
    category: 'Interior/Exterior',
    description: 'Proteção contra sol e chuva, super cobertura e acabamento perfeito, disfarçando imperfeições com alto rendimento. Certificado INMETRO e ISO 9001.',
    price: 'a partir de R$ 130,00',
    accent: 'Alta resistência',
    image: mestreBellacor,
  },
  {
    name: 'Impermeabilizante Tecplus Top Quartzolit',
    category: 'Impermeabilização',
    description: 'Argamassa polimérica semi-flexível que suporta pressão positiva e negativa. Ideal para banheiros e cozinhas, aplicação com rolo ou trincha. Embalagem de 4kg.',
    price: 'a partir de R$ 78,00',
    accent: 'Semi-flexível',
    image: tecplusTop,
  },
  {
    name: 'Espuma Expansiva Quartzolit',
    category: 'Vedação',
    description: 'Espuma de poliuretano para vedação e fixação de portas e janelas. Expansão potencializada com umidade. Frasco de 500ml (340g).',
    price: 'a partir de R$ 60,00',
    accent: 'Vedação',
    image: espumaExpansiva,
  },
  {
    name: 'Suvinil Toque Seda',
    category: 'Interior/Exterior',
    description: 'Acabamento acetinado e sofisticado, fácil de limpar, com boa uniformidade e disfarce de pequenas imperfeições. Lata de 18L.',
    price: 'a partir de R$ 140,00',
    accent: 'Acetinado',
    image: suvinilSeda,
  },
  {
    name: 'Coral Renova Creme de Pintura',
    category: 'Interior/Exterior',
    description: 'Pronto para uso, com baixo respingamento e acabamento fosco. Pinta até sobre o mofo, sem cheiro e lavável. Rende até 10 paredes de 10m² cada. Lata de 16L.',
    price: 'a partir de R$ 110,00',
    accent: 'Sem cheiro',
    image: coralRenova,
  },
];

const ProductsPage = () => {
  return (
    <div className="products-page">
      <div className="page-hero products-hero">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-7">
              <span className="eyebrow eyebrow-light">Produtos da Mafra Tintas</span>
              <h1 className="text-white">Soluções para cada projeto com qualidade profissional.</h1>
              <p>
                Oferecemos tintas, primers e acabamentos com alto desempenho para uso residencial,
                comercial e industrial.
              </p>
            </div>
            <div className="col-lg-5">
              <div className="hero-panel">
                <h4>Atendimento especializado</h4>
                <p>Conte com nosso time para indicar a melhor solução para seu ambiente.</p>
                <a href="https://wa.me/5544999491158?text=Oi!%20Gostaria%20de%20falar%20com%20a%20Mafra%20Tintas%20sobre%20produtos." className="btn btn-primary" target="_blank" rel="noreferrer">
                  Falar com especialista
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="section-heading text-center mb-5">
          <span className="eyebrow">Nossos destaques</span>
          <h2>Produtos com acabamento confiável e durabilidade comprovada.</h2>
        </div>

        <div className="row g-4">
          {products.map((product) => (
            <div className="col-lg-4 col-md-6 d-flex" key={product.name}>
              <div className="product-card d-flex flex-column w-100">
                <div className="product-image">
                  <img src={product.image} alt={product.name} loading="lazy" />
                </div>
                <div className="product-card__body d-flex flex-column flex-grow-1">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="product-tag">{product.accent}</span>
                    <span className="product-price">{product.price}</span>
                  </div>
                  <h3>{product.name}</h3>
                  <p className="flex-grow-1">{product.description}</p>
                  
                  <a
                    href={buildWhatsAppLink(product.name)}
                    className="btn btn-primary w-100 mt-auto"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Comprar no WhatsApp
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsPage;